import { ISaleChannel } from "../../../../models/sale-channel";
import MainApi from "../../../../services/mainApi.service";

const serviceURL = process.env.REACT_APP_MAIN + "/api/v1/SalesChannel/";
const translationsPath = "page.4uSalesContract.registers.salesChannel.";

export const salesChannelService = new MainApi<ISaleChannel>(serviceURL);
export const buildTPath = (field: string) => translationsPath + field;
